import FunnelStepSelect from '@/Components/Funnel/FunnelStepSelect.vue'
import FunnelStepContact from '@/Components/Funnel/FunnelStepContact.vue'
import Success from '@/Components/Stairlift/Steps/Success.vue'
import Result from '@/Components/Stairlift/Steps/Result.vue'

export function useStairliftFunnelMini() {
    const funnel = {
        routeName: 'stairlift.funnel.step',
        tagEvents: {
            contact: 'mini_stairlift_contact_form_submitted',
        },
    }

    const steps = [
        // {
        //     id: "orderer",
        //     key: "orderer",
        //     type: "select",
        //     component: FunnelStepSelect,
        //     formField: "orderer",
        //     title: {
        //         direct: "Suchen Sie für sich oder ein Familienmitglied?",
        //         indirect: "Suchen Sie für sich oder ein Familienmitglied?",
        //     },
        //     options: [
        //         {
        //             key: "direct",
        //             label: "Für mich",
        //             img: "/img/icons/direct.png",
        //         },
        //         {
        //             key: "indirect",
        //             label: "Für ein Familienmitglied",
        //             img: "/img/icons/indirect.png",
        //         },
        //     ],
        //     next: (form) => "stairlift_type",
        // },

        // ----- Lift Section ------------
        {
            id: 'stairlift_type',
            key: 'stairlift_type',
            type: 'select',
            component: FunnelStepSelect,
            formField: 'stairlift_type',
            title: {
                direct: 'Was für einen Lift suchen Sie?',
                indirect: 'Was für ein Lift wird benötigt?',
            },
            options: [
                {
                    key: 'seated_lift',
                    label: 'Sitzlift',
                    img: '/img/icons/sitzlift.png',
                },
                {
                    key: 'platform_lift',
                    label: 'Plattformlift',
                    img: '/img/icons/plattform.png',
                },
                {
                    key: 'hub_lift',
                    label: 'Hublift',
                    img: '/img/icons/lift.png',
                },
                {
                    key: 'unknown',
                    label: 'Weiß nicht',
                    img: '/img/icons/unknown.png',
                },
            ],
            next: () => 'stairlift_location',
        },
        {
            id: 'stairlift_location',
            key: 'stairlift_location',
            type: 'select',
            component: FunnelStepSelect,
            formField: 'stairlift_location',
            title: {
                direct: 'Wo soll der Lift installiert werden?',
                indirect: 'Wo soll der Lift installiert werden?',
            },
            options: [
                {
                    key: 'indoors',
                    label: 'Innen',
                    img: '/img/icons/inside.png',
                },
                {
                    key: 'outdoors',
                    label: 'Außen',
                    img: '/img/icons/outside.png',
                },
                {
                    key: 'indoors_outdoors',
                    label: 'Innen und Außen',
                    img: '/img/icons/both.png',
                },
                {
                    key: 'unknown',
                    label: 'Weiß nicht',
                    img: '/img/icons/unknown.png',
                },
            ],
            next: () => 'stairlift_form',
        },
        {
            id: 'stairlift_form',
            key: 'stairlift_form',
            type: 'select',
            component: FunnelStepSelect,
            formField: 'stairlift_form',
            title: {
                direct: 'Welche Form hat Ihre Treppe?',
                indirect: 'Welche Form hat die Treppe?',
            },
            options: [
                {
                    key: 'straight',
                    label: 'Gerade',
                    img: '/img/icons/straight.png',
                },
                {
                    key: 'curved',
                    label: 'Kurvige',
                    img: '/img/icons/curvy.png',
                },
                {
                    key: 'curved_podium',
                    label: 'L-Form mit Podest',
                    img: '/img/icons/podium.png',
                },
                {
                    key: 'other',
                    label: 'Andere Form',
                    img: '/img/icons/other.png',
                },
            ],
            next: () => 'stairlift_floor',
        },
        {
            id: 'stairlift_floor',
            key: 'stairlift_floor',
            type: 'select',
            component: FunnelStepSelect,
            formField: 'stairlift_floor',
            title: {
                direct: 'Über wie viele Etagen soll der Lift gehen?',
                indirect: 'Über wie viele Etagen soll der Lift gehen?',
            },
            options: [
                {
                    key: '1_floor',
                    label: 'Eine Etage',
                    img: '/img/icons/1-etage.png',
                },
                {
                    key: '2_floor',
                    label: 'Zwei Etagen',
                    img: '/img/icons/2-etage.png',
                },
                {
                    key: '2_plus_floor',
                    label: 'Mehr als zwei Etagen',
                    img: '/img/icons/2-plus-etage.png',
                },
                {
                    key: 'unknown',
                    label: 'Weiß nicht',
                    img: '/img/icons/unknown.png',
                },
            ],
            next: () => 'contact',
        },

        {
            id: 'result-short',
            key: 'result',
            type: 'custom',
            component: Result,
            text: "Vielen Dank für Ihre Angaben. Jetzt können Sie ein kostenloses Beratungsgespräch vereinbaren, bei dem ein Leben-ohne-Grenzen-Experte Ihnen helfen wird, den passenden Treppenlift-Anbieter in Ihrer Nähe zu finden.",
            checkTextList: [ 
                "Verlässliche und professionelle Beratung",
                "Treppenlift geeignet für eine Förderung", 
                "Hilfe beim Förderantrag"
            ],
            next: () => 'contact-short',
        },
        {
            id: 'contact',
            key: 'contact',
            type: 'custom',
            component: FunnelStepContact,
            text: 'Jetzt kostenloses Erstgespräch vereinbaren und den passenden regionalen Treppenliftanbieter für Ihre individuellen Anforderungen empfohlen bekommen.',
            checkTextList: [
                'Verlässliche und professionelle Beratung',
                'Treppenlift geeignet für eine Förderung',
                'Hilfe beim Förderantrag',
            ],
            next: () => 'success',
        },

        {
            id: 'success',
            key: 'success',
            type: 'custom',
            component: Success,
        },
    ]

    return {
        funnel,
        steps,
    }
}
